import {ICompanySyncstep, IExportAttribute, IExportFlow, IObjectType, IRuleset, TExportAttributeType} from "../../index";
import {IExportFlowMutable} from "./index";
import {_} from 'lodash';
import * as ko from "knockout";
import {ObjectTypeId, TEXT_WRAPPER_START} from "../../constants";
import {global} from "../../appContext";
import {ErrorObject} from "../../error/ErrorObject";
import {IRequestObject} from "../../req";
import {nsRule} from "../ruleset/mutable/rule/nsRule";
import {nsParentPath} from "./parentpath/fn";
import TYPE = nsParentPath.TYPE;

export namespace nsExportTemplate {

    export const ERROR_AREA = "export.template.mutable";

    export const MAIL_TYPE: TExportAttributeType = "Mail";
    export const VISMA_TYPE: TExportAttributeType = "Visma";
    export const PARENT_PATH_TYPE: string = "parentPath";
    export const PRIMARY_SMTP_DOMAIN_PREFIX = `[MAIL,displayname]@`;
    export const PRIMARY_SMTP_DOMAIN_EXAMPLE = `${PRIMARY_SMTP_DOMAIN_PREFIX}ditt.domene.her`;


    // -----------------------------------------------------------------------------------------------------------------
    // Filter functions
    // -----------------------------------------------------------------------------------------------------------------

    export const isExportFlowMutableParentPath = (item: IExportFlowMutable) => {
        return item.targetattribute?.()?.name == PARENT_PATH_TYPE;
    };
    export const isExportFlowMutableVisma = (item: IExportFlowMutable) => {
        return item.targetattribute?.()?.type == VISMA_TYPE;
    };
    export const isExportFlowMutableOrdinary = (item: IExportFlowMutable) => !isExportFlowMutableParentPath(item) && !isExportFlowMutableVisma(item);
    export const isExportFlowMutableOrdinaryExport = (item: IExportFlowMutable) => isExportFlowMutableOrdinary(item) && !item.$original.inbound;
    export const isExportFlowMutableOrdinaryImport = (item: IExportFlowMutable) => isExportFlowMutableOrdinary(item) && item.$original.inbound;

    export const isExportFlowParentPath = (item: IExportFlow) => item.targetattribute == PARENT_PATH_TYPE;
    export const isExportFlowVisma = (item: IExportFlow) => item.targetattributetype == VISMA_TYPE;
    export const isExportFlowInbound = (item: IExportFlow) => !!item.inbound;
    const isExportFlowOrdinary = (item: IExportFlow) => !isExportFlowParentPath(item) && !isExportFlowVisma(item);
    export const isExportFlowOrdinaryExport = (item: IExportFlow) => isExportFlowOrdinary(item) && !isExportFlowInbound(item);
    export const isExportFlowOrdinaryImport = (item: IExportFlow) => isExportFlowOrdinary(item) && isExportFlowInbound(item);

    export const isExportAttributeOrdinaryType = (item: IExportAttribute) => item.type != VISMA_TYPE && item.name != PARENT_PATH_TYPE;

    // -----------------------------------------------------------------------------------------------------------------

    export function exportFlowToMutable(item: IExportFlow, attributes: IExportAttribute[]): IExportFlowMutable {
        const attribute = attributes.find((attr: IExportAttribute) => attr.name.toLowerCase() == item.targetattribute.toLowerCase());
        const targetAttributeMode_initial = item.sourceattribute?.startsWith(TEXT_WRAPPER_START) ? nsRule.InputMode.Text: nsRule.InputMode.Select
        return {
            $original: _.cloneDeep(item),
            expression: ko.observable(item.expression),
            nullable: ko.observable(item.nullable),
            syncnext: ko.observable(item.syncnext),
            objecttype: ko.observable<IObjectType | null>(item.objecttype),
            ruleset: ko.observable<IRuleset | null>(item.ruleset),
            sourceattribute: ko.observable(item.sourceattribute),
            targetattribute: ko.observable(item.inbound ? item.targetattribute : attribute),
            targetAttributeMode: ko.observable<nsRule.InputMode>(targetAttributeMode_initial),
            type: ko.observable<TYPE | undefined>(undefined),
            updateforcesdeltasync: ko.observable(item.updateforcesdeltasync),
            errExpression: new ErrorObject({name: 'expression'}),
            errRuleset: new ErrorObject({name: 'ruleset'}),
            errSourceAttribute: new ErrorObject({name: 'sourceAttribute'}),
            errTargetAttribute: new ErrorObject({name: 'targetAttribute'}),
            errType: new ErrorObject({name: 'type'}),
        }
    }

    export function createExportFlowMutable(inbound: boolean = false): IExportFlowMutable {
        return {
            $original: {
                expression: "",
                id: 0,
                inbound: inbound,
                nullable: false,
                objecttype: null!,
                ruleset: null!,
                sourceattribute: "",
                syncstep: null!,
                syncnext: false,
                targetattribute: "",
                targetattributetype: "String",
                updateforcesdeltasync: false
            },
            expression: ko.observable(""),
            nullable: ko.observable(false),
            objecttype: ko.observable(null),
            ruleset: ko.observable(null),
            sourceattribute: ko.observable(""),
            syncnext: ko.observable(false),
            targetAttributeMode: ko.observable<nsRule.InputMode>(nsRule.InputMode.Select),
            targetattribute: ko.observable(null),
            type: ko.observable<TYPE | undefined>(undefined),
            updateforcesdeltasync: ko.observable(false),
            errExpression: new ErrorObject({name: 'expression'}),
            errRuleset: new ErrorObject({name: 'ruleset'}),
            errSourceAttribute: new ErrorObject({name: 'sourceAttribute'}),
            errTargetAttribute: new ErrorObject({name: 'targetAttribute'}),
            errType: new ErrorObject({name: 'type'}),
        };
    }

    export enum Section {
        MappingsExport,
        MappingsImport,
        ObjectType,
        ParentPath,
        Ruleset,
        Syncstep,
        Visma,
    }

    export function showDBPD(objecttype: IObjectType | null, syncstep: ICompanySyncstep | null): boolean {
        const a = objecttype?.id == ObjectTypeId.User || objecttype?.id == ObjectTypeId.Group;
        const b = !!(syncstep && syncstep.syncstep.isexportable);
        return a && b;
    }

    export function getExportAttributes(syncstepid: number, objectTypeId: ObjectTypeId): IRequestObject<IExportAttribute[]> {
        const promise = global.getPromiseRequest('getexportattributes');
        const request = promise
            .request({
                syncstepid: syncstepid,
                objecttypeid: objectTypeId,
            })
        return {request, promise}
    }

}
